export default {"src":"/_next/static/media/hush.eb27ee04.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};